import { ENewbuildingPromoFeaturesActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setNewbuildingPromoVisibility = actionGenerator<
  ENewbuildingPromoFeaturesActionType.SetNewbuildingPromoVisibility,
  boolean
>(ENewbuildingPromoFeaturesActionType.SetNewbuildingPromoVisibility);
